
import {INTERVIEWER_JOB_PLANNED_REQUEST, INTERVIEWER_JOB_PLANNED_SUCCESS,INTERVIEWER_JOB_PLANNED_FAIL} from "../constants/AuthConstant"

const axios = require("axios");
export const InterviewerInterviewPlanned = (id) => {
    return function (dispatch) {
      dispatch({
        type: INTERVIEWER_JOB_PLANNED_REQUEST,
        payload: true,
      });
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/interview/get_interview_by_interviewerId?interviewerId=${id}&pageNumber=0&pageSize=10&flag=true`,
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      };
      axios(OPTION)
        .then((res) => {
          dispatch(loadAllDetailsPre(res.data));
        })
        .catch((error) => {
          dispatch({
            type: INTERVIEWER_JOB_PLANNED_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
        });
    };
  };

  export const loadAllDetailsPre = (data) => {
    return {
      type: INTERVIEWER_JOB_PLANNED_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };